import { CountryCodes } from '../../../../../common/constants/countries';
import { FileAttachmentType } from '../../../../../common/models/file-attachment.model';
import { TruckSizeUnion } from '../../../../../common/constants/truck-size';
import { LocalDate } from '../../../../models';

export enum AllocationViewAttachmentTypeEnum {
  Initial = 'INITIAL',
  Registration = 'REGISTRATION',
  HubArrival = 'HUB_ARRIVAL',
  HubDeparture = 'HUB_DEPARTURE',
  HubRelease = 'HUB_RELEASE',
  DockArrival = 'DOCK_ARRIVAL',
  DockDeparture = 'DOCK_DEPARTURE',
  SealCheck = 'SEAL_CHECK',
  SealCheckConfirmation = 'SEAL_CHECK_CONFIRMATION',
}

export class UliItemQuestionModel {
  question: string;
  answer: boolean;
}

export interface Signature {
  fullName: string;
  pictureId: string;
}

export interface UliItemLoanedEquipment {
  loanerPhoneExtId: string;
  loanerPhoneId: number;
  loanerPhoneReturned: boolean;
  permanentBadge: boolean;
  phoneLoaned: boolean;
  phoneNumber: string;
  visitorBadgeLoaned: boolean;
  visitorBadgeReturned: boolean;
  visitorBadgeNumber: string;
}

export interface CombinedAttachmentsModel {
  uliAttachmentViews: UliItemAttachmentModel[];
  stTourExecutionAttachmentViews: STItemAttachmentModel[];
}

export class UliItemAttachmentModel {
  creationDate: LocalDate;
  createdBy: string;
  executionStep: AllocationViewAttachmentTypeEnum;
  securityCheck: {
    questionnaireItems: UliItemQuestionModel[];
    securityCheckPassed: boolean;
  };
  additionalInfo: {
    checkNeeded: boolean;
    comment: string;
    attachments: UliAttachmentsModel[];
  };
  driverSignature: Signature;
  workerSignature: Signature;
  sealCheck: {
    truckSeal: UliAttachmentsSealModel;
    trailerSeal: UliAttachmentsSealModel;
  };
  loanedEquipment: UliItemLoanedEquipment;
  initialAttachments: SMSConsentAttachmentModel[];

  constructor(params?: UliItemAttachmentModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class STItemAttachmentModel {
  truckId: number;
  truckPlate: string;
  plateCountryCode: CountryCodes;
  truckSize: TruckSizeUnion;
  attachments: UliItemAttachmentModel[];

  constructor(params?: UliItemAttachmentModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class SMSConsentAttachmentModel {
  id: number;
  phoneNumber: string;
  phoneCountry: string;
  consentGiven: boolean;
  consentTimestamp: string;
  consentSignaturePicId: string;
  author: string;
}

export class UliAttachmentsModel {
  attachmentId: string;
  mimeType: FileAttachmentType;
  filename: string;
}

export class UliAttachmentsSealModel extends UliAttachmentsModel {
  sealNumber: string;
}
